import script from './SbFlagIcon.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb-flag",class:( _obj = {}, _obj[("sb-flag--" + _vm.size)] = !!_vm.size, _obj['sb-flag--border'] =  _vm.hasBorder, _obj ),attrs:{"icon":_vm.icon}},[_c('CustomImage',{staticClass:"sb-flag__picture",attrs:{"src":("/static/img/flags/" + (encodeURI(_vm.flag)))}}),_vm._v(" "),(_vm.icon === _vm.IconType.Indicator)?_c('span',{staticClass:"sb-flag__indicator"}):_vm._e(),_vm._v(" "),(_vm.icon === _vm.IconType.Img)?_c('img',{staticClass:"sb-flag__icon",attrs:{"src":_vm.iconImgSrc}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-198f97d6_0", { source: ".sb-flag[data-v-198f97d6]{position:relative}.sb-flag--small[data-v-198f97d6]{width:16px;height:16px}.sb-flag--small .sb-flag__icon[data-v-198f97d6]{bottom:-5px;right:-9px}.sb-flag--medium[data-v-198f97d6]{width:20px;height:20px}.sb-flag--medium .sb-flag__icon[data-v-198f97d6]{bottom:-6px;right:-6px}.sb-flag--large[data-v-198f97d6]{width:24px;height:24px}.sb-flag--large .sb-flag__icon[data-v-198f97d6]{bottom:-5px;right:-5px}.sb-flag__picture[data-v-198f97d6]{width:inherit;height:inherit}.sb-flag__picture[data-v-198f97d6] img{width:inherit;height:inherit;border-radius:50%}.sb-flag--border .sb-flag__picture[data-v-198f97d6] img{border:1px solid var(--system-border-on-elevation-tertiary)}.sb-flag__indicator[data-v-198f97d6]{position:absolute;bottom:-1px;right:-1px;display:block;width:8px;height:8px;border-radius:50%;background:var(--system-graphics-on-elevation-success)}.sb-flag__icon[data-v-198f97d6]{position:absolute;width:16px;height:16px;border:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-198f97d6";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
